import React, { Fragment } from "react";
import { Tooltip, TooltipWrapper } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import "./ProjectLanguages.css";
import muiImage from '../../assets/images/mui-logo.png'

function ProjectLanguages(props) {
  return (
    <div className="software-skills-main-div">
      <ul className="dev-icons-languages">
        {props.logos.map((logo, index) => {
          return (
            <Fragment key={logo.name}>
              <TooltipWrapper tooltipId={logo.name.trim() + index}>
                <li
                  className="software-skill-inline-languages"
                  name={logo.name}
                >
                  {console.log(logo.iconComponent ? logo.iconComponent: 'aaa')}
                  {!logo.iconComponent ? (
                    <span
                    className="iconify"
                    data-icon={logo.iconifyClass}
                    data-inline="false"
                  ></span>
                  ): (
                    <img src={muiImage} height={20} width={20}/>
                  )}
                  
                </li>
              </TooltipWrapper>
              <Tooltip
                id={logo.name.trim() + index}
                content={logo.name}
                style={{ fontSize: "16px" }}
                variant={props.theme.name === "dark" ? "light" : "dark"}
              />
            </Fragment>
          );
        })}
      </ul>
    </div>
  );
}

export default ProjectLanguages;
